import { Factory } from 'fishery';

import { Group } from '../group';

export const groupFactory = Factory.define<Group>(({ sequence }) => ({
	id: `group-${sequence}`,
	name: `Group ${sequence}`,
	health: {}
}));
